var render = function render(){var _vm=this,_c=_vm._self._c;return _c('warning',{attrs:{"icon":_vm.$icons.warning,"title":_vm.$t('notFound.title'),"content":_vm.$t('notFound.details'),"show-home":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }